import { forwardRef, type ForwardedRef } from 'react';
import clsx from 'clsx';
import {
  Checkbox as AriaCheckbox,
  type CheckboxProps as AriaCheckboxProps,
  composeRenderProps,
} from 'react-aria-components';

import { CheckboxCheckmark } from './CheckboxCheckmark';
import { Text } from '../typography';
import styles from './Checkbox.module.css';

export type Props = Pick<
  AriaCheckboxProps,
  | 'slot'
  | 'name'
  | 'value'
  | 'onChange'
  | 'isSelected'
  | 'isDisabled'
  | 'isInvalid'
  | 'isIndeterminate'
  | 'isRequired'
  | 'children'
> & {
  alignment?: 'top' | 'center';
};

export const Checkbox = forwardRef(function _Checkbox(
  { children: childrenWithRenderProps, alignment = 'center', ...rest }: Props,
  ref: ForwardedRef<HTMLLabelElement>,
) {
  return (
    <AriaCheckbox {...rest} ref={ref} className={clsx(styles.root, styles[`alignment-${alignment}`])}>
      {composeRenderProps(childrenWithRenderProps, (children, { isDisabled, ...restRenderProps }) => {
        return (
          <>
            <CheckboxCheckmark {...restRenderProps} isDisabled={isDisabled} />
            {children ? (
              <Text color={isDisabled ? 'gray-500' : 'gray-800'} asChild>
                <div>{children}</div>
              </Text>
            ) : null}
          </>
        );
      })}
    </AriaCheckbox>
  );
});
